// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2wtav","cell":"ColumnAccessor_cell__16vCj","firstCellAccent":"ColumnAccessor_firstCellAccent__3H0Ts"};